export default {
  props: {
    disclaimer: {
      type: String,
      default: '',
    },
  },
};
